import Title from "../components/ui/Title";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";

export default function UnsupporterBrowserPage() {
  return (
    <div>
      <div className='flex flex-row gap-5 mb-6 items-center'>
        <Link to='/revues-numeriques'>
          <button className='rounded-full bg-white border p-3 hover:bg-gray-50 active:bg-gray-100'>
            <ArrowLeftIcon />
          </button>
        </Link>
        <Title>Navigateur incompatible</Title>
      </div>
      <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded  mb-4'>
        <div>
          Votre navigateur ne prend pas en charge l'affichage de la revue numérique. Veuillez utiliser une version
          récente de :
          <ul className='list-disc list-inside mt-2'>
            <li>Chrome (version 119+)</li>
            <li>Edge (version 119+)</li>
            <li>Firefox (version 121+)</li>
            <li>Safari (version 17.4+)</li>
            <li>Opera (version 106+)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
